import { TableCell, withStyles } from "@material-ui/core"
import React from "react"

const styles = {
    th: {
        fontWeight: 600,
    },
}

const thMd = ({ classes, children }) =>
    <TableCell classes={{ head: classes.th }} children={children} />

export const ThMd = withStyles(styles)(thMd)